export default __webpack_public_path__ + "static/media/495.ee94c037.png";